import { render } from "./ArticleList.vue?vue&type=template&id=6bb8a51c&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"

import "./ArticleList.vue?vue&type=style&index=0&id=6bb8a51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb8a51c"]])

export default __exports__